<template>
  <div
    class="student-search-alert-error d-flex items-align-center"
    :class="customClasses"
  >
    <div class="w-100 text-left">
      <div v-if="message || $slots.default" class="d-inline">
        <em v-if="isAlertMode" class="fa fa-bell-exclamation" />
        <em v-else class="fa fa-times-circle" />
      </div>
      <p v-if="message" class="text-left d-inline" v-html="message" />
      <p v-else class="text-left d-inline">
        <slot />
      </p>
      <slot name="action-text" />
    </div>
    <span v-if="canClose" class="closebtn" @click="$emit('close')">
      &times;
    </span>
  </div>
</template>

<style scoped>
.closebtn {
  margin-left: 15px;
  color: #af6708;
  font-weight: bold;
  float: right;
  font-size: 22px;
  line-height: 20px;
  cursor: pointer;
  transition: 0.3s;
}

.student-search-alert-error {
  background-color: #ffebeb;
  border: 1px solid #ff5b5c;
  padding: 10px;
  margin: 16px 0;
  border-radius: 4px;
  position: relative;
}
.student-search-alert-error.pl-0 {
  padding-left: 0;
}

.withoutspacing {
  margin-left: 0px;
  margin-right: 0px;
}

.student-search-alert-error p {
  text-align: left;
  font: Lato, Regular;
  letter-spacing: 0;
  color: #ff5b5c;
  margin-bottom: 0px;
  font-weight: normal;
}

.student-search-alert-error em {
  color: #ff5b5c;
  font-size: 18px;
  padding-right: 10px;
  margin-left: -6px;
}

.student-search-alert-error.alert p,
.student-search-alert-error.alert em {
  color: #af6708;
}
.student-search-alert-error.alert {
  background: #fff5e8;
  border: 1px solid #fdac41;
}
.student-search-alert-error.no-border {
  border: none;
  background-color: transparent;
  margin: 0;
  padding-top: 0;
  padding-bottom: 0;
  padding-left: 5px;
}
.student-search-alert-error.no-border p {
  font-size: 14px;
}
.student-search-alert-error.no-border.pt-16 {
  padding-top: 16px;
}
.student-search-alert-error.no-icon {
  padding-left: 0;
}
.student-search-alert-error.no-icon em {
  display: none;
}
.borderless {
  border: none !important;
}
</style>

<script>
export default {
  name: 'Error',
  meta: {
    description: 'Componente personalizado para alertas de error.',
    slots: {
      default: {
        type: 'component',
        valid: [],
      },
    },
  },
  props: {
    message: {
      type: String,
      default: '',
      meta: {
        description: 'Mensaje mostrado en el interior del componente',
        example: 'Texto requerido',
      },
    },
    isAlertMode: {
      type: Boolean,
      default: false,
      meta: {
        description: 'Establece modo de alerta',
        example: 'true',
      },
    },
    isBorderless: {
      type: Boolean,
      default: false,
      meta: {
        description:
          'Remueve bordes. Solo deja el mensaje de alerta/error y el icono.',
        example: 'true',
      },
    },
    variant: {
      type: String,
      default: '',
      meta: {
        description: 'Propiedad para definir estilos',
        example: 'Texto requerido',
      },
    },
    canClose: {
      type: Boolean,
      default: false,
      meta: {
        description: 'Habilta botón para cerrar el panel',
        example: 'true',
      },
    },
  },
  computed: {
    customClasses() {
      let classes = this.isAlertMode ? 'alert ' + this.variant : this.variant;

      if (this.isBorderless) classes += ' borderless';

      return classes;
    },
  },
};
</script>
